import { handleFormValidations } from './utils/form_validations'
import StantMultiselect from "../../utils/stant_multiselect.coffee"
import StantMultiSelectLevels from "../../utils/stant_multiselect_levels.coffee"

const EMPRESA_VALUE_PREFIX = 'empresa-'
const OBRAS_CLASS = 'empresa-obras-multiselect'
const DEBOUNCE_MS = 200

// Guarda contra respostas AJAX fora de ordem: só a última requisição renderiza.
let obrasRequestSeq = 0
let debounceTimer = null

$(document).on('turbolinks:load', function () {
    handleFormValidations()

    new StantMultiselect('empresa-multiselect').add_listener()

    const $wrap = $('.js-obras-selector-wrap')
    if ($wrap.length) {
        // Carrega as obras da seleção inicial (por padrão só a empresa atual).
        // As obras NÃO vêm renderizadas server-side (grupo pode ter milhares e
        // travava a tela); são buscadas sob demanda em #obras_for_empresas.
        loadObras($('.empresa-multiselect').val() || [])
    }

    $(document).on('change', '#js-company-reports-report-type-select', function () {
        const formElement = $('#company_reports_form')
        formElement.attr('action', $(this).val() || '/company_reports_form/')
    })

    $(document).off('change.empresaFilter').on('change.empresaFilter', '.empresa-multiselect', function () {
        const selected = $(this).val() || []
        if (debounceTimer) clearTimeout(debounceTimer)
        debounceTimer = setTimeout(function () { loadObras(selected) }, DEBOUNCE_MS)
    })
})

function loadObras(selectedEmpresaIds) {
    const selected = (selectedEmpresaIds || []).map(String)
    const $wrap = $('.js-obras-selector-wrap')
    if (!$wrap.length) return

    const $select = $('.' + OBRAS_CLASS)
    const $form = $('#company_reports_form')
    const $warning = $('.js-obras-integral-warning')
    const $header = $('.js-obras-select-header')
    const $loading = $('.js-obras-loading')

    teardownWidget($select)

    // Nenhuma empresa selecionada: seletor vazio, sem aviso.
    if (!selected.length) {
        $select.empty()
        $wrap.removeClass('hide')
        $header.removeClass('hide')
        $warning.addClass('hide')
        $loading.addClass('hide')
        $form.attr('data-obras-integral', 'false')
        return
    }

    const url = $wrap.attr('data-obras-url')
    const seq = ++obrasRequestSeq

    $warning.addClass('hide')
    $loading.removeClass('hide')

    $.ajax({
        url: url,
        method: 'GET',
        dataType: 'json',
        data: { empresa_ids: selected }
    }).done(function (payload) {
        if (seq !== obrasRequestSeq) return // resposta obsoleta
        renderObras(payload)
    }).fail(function () {
        if (seq !== obrasRequestSeq) return
        $loading.addClass('hide')
        teardownWidget($select)
        $select.empty()
        $wrap.removeClass('hide')
        $header.removeClass('hide')
        $form.attr('data-obras-integral', 'false')
    })
}

function renderObras(payload) {
    const $select = $('.' + OBRAS_CLASS)
    const $wrap = $('.js-obras-selector-wrap')
    const $form = $('#company_reports_form')
    const $warning = $('.js-obras-integral-warning')
    const $header = $('.js-obras-select-header')
    const $loading = $('.js-obras-loading')

    $loading.addClass('hide')
    teardownWidget($select)
    $select.empty()

    // Modo integral: seleção gera obras demais; sem seletor, aviso visível,
    // obras_ids vazio -> controller extrai todas as obras das empresas.
    if (payload && payload.integral) {
        $wrap.addClass('hide')
        $header.addClass('hide')
        $warning.removeClass('hide')
        $form.attr('data-obras-integral', 'true')
        return
    }

    $form.attr('data-obras-integral', 'false')
    $warning.addClass('hide')
    $header.removeClass('hide')
    $wrap.removeClass('hide')

    const empresas = (payload && payload.empresas) || []
    empresas.forEach(function (empresa) {
        const headerValue = EMPRESA_VALUE_PREFIX + empresa.empresa_id

        $('<option></option>')
            .attr('value', headerValue)
            .attr('data-empresa-header', empresa.empresa_id)
            .addClass('js-empresa-header-option')
            .text(empresa.empresa_name || '')
            .appendTo($select)

        ;(empresa.obras || []).forEach(function (obra) {
            $('<option></option>')
                .attr('value', obra.id)
                .attr('data-empresa_id', headerValue)
                .text(obra.titulo || '')
                .appendTo($select)
        })
    })

    new StantMultiSelectLevels(OBRAS_CLASS, 'data-empresa_id').add_listener()
    markEmpresaHeadersWhenReady(0)
}

function teardownWidget($select) {
    if ($select.length && $select.hasClass('jqmsLoaded')) {
        try { $select.multiselect('destroy') } catch (e) { /* noop */ }
    }
}

function markEmpresaHeaders() {
    const $obrasSelect = $('.' + OBRAS_CLASS)
    if (!$obrasSelect.length) return
    const $wrap = $obrasSelect.next('.ms-options-wrap')
    $wrap.find('li').each(function () {
        const $li = $(this)
        const $checkbox = $li.find('> label > input[type="checkbox"]').first()
        if (!$checkbox.length) return
        const value = String($checkbox.val() || '')
        if (value.indexOf(EMPRESA_VALUE_PREFIX) === 0) {
            $li.addClass('js-empresa-header-li')
        }
    })
}

function markEmpresaHeadersWhenReady(attempts) {
    const $obrasSelect = $('.' + OBRAS_CLASS)
    if (!$obrasSelect.length) return
    if (!$obrasSelect.hasClass('jqmsLoaded')) {
        if (attempts < 40) {
            setTimeout(function () { markEmpresaHeadersWhenReady(attempts + 1) }, 25)
        }
        return
    }
    markEmpresaHeaders()
}
